import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from '../app/LanguageContext';
import axios from 'axios';

const BibleBooksPage = () => {

    // Initialisation de la traduction
    const { t } = useTranslation();

    const [books, setBooks] = useState([]);
    const { language, changeLanguage } = useContext(LanguageContext);

    useEffect(() => {
        const fetchBooks = async () => {
            try {
                const response = await fetch('https://labs.bible.org/api/?books&type=json');
                const data = await response.json();
                const translatedData = data.map((item) => ({
                    ...item,
                    name: t(item.name), // Traduire le nom
                }));
                setBooks(translatedData);
            } catch (error) {
                console.error('Error fetching Bible books:', error);
            }
        };
        fetchBooks();
    }, []);



    // recupérer la listes des versets d'un livre biblique
    const [verses, setVerses] = useState([]);
    const fetchVerses = async () => {
        try {
          const response = await axios.get(
            'https://bible-api.com/{version}.{book}.{chapter}'
          );
  
          setVerses(response.data.verses);
        } catch (error) {
          console.error('Error fetching verses:', error);
        }
      };
  
  


    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4 translatable">Plan de lecture de la bible</h1>
            <p className="my-2 translatable">Bientôt disponible</p>
            <div>
                <button className="btn btn-outline-primary " onClick={() => { changeLanguage('en') ; }}>English</button>
                <button className="btn btn-outline-primary " onClick={() => { changeLanguage('fr') ; }}>Français</button>
            </div>
            <div className="flex flex-wrap">
                {books.map((book) => (
                    <div key={book.name} className="p-2">
                        <button className="bg-lime-500 hover:bg-lime-700 text-white font-bold py-2 px-4 rounded translatable">
                            {t(book.name)}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BibleBooksPage;
